var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { plainToClass } from 'class-transformer';
import { Clinic, Employee } from 'models';
import Model from 'models/Model';
var ReceptionDesk = /** @class */ (function (_super) {
    __extends(ReceptionDesk, _super);
    function ReceptionDesk() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ReceptionDesk.prototype.getId = function () {
        return Number(this.id);
    };
    ReceptionDesk.prototype.getName = function () {
        return this.name;
    };
    ReceptionDesk.prototype.setName = function (name) {
        this.name = name;
    };
    ReceptionDesk.prototype.getCode = function () {
        return this.code || '';
    };
    ReceptionDesk.prototype.setCode = function (code) {
        this.code = code;
    };
    ReceptionDesk.prototype.isActive = function () {
        return this.active !== false;
    };
    ReceptionDesk.prototype.setActive = function (active) {
        this.active = active;
    };
    ReceptionDesk.prototype.getClinicId = function () {
        return Number(this.clinic_id);
    };
    ReceptionDesk.prototype.setClinicId = function (clinicId) {
        this.clinic_id = clinicId;
    };
    ReceptionDesk.prototype.getClinic = function () {
        return this.clinic ? plainToClass(Clinic, this.clinic) : undefined;
    };
    ReceptionDesk.prototype.getEmployees = function () {
        return plainToClass(Employee, (this.employees || []));
    };
    ReceptionDesk.prototype.getEmployeeIds = function () {
        return this.getEmployees().map(function (employee) { return employee.getId(); });
    };
    return ReceptionDesk;
}(Model));
export default ReceptionDesk;
